"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NO_PRODUCTION_ROLE_KEY = void 0;
/**
 * The role-config key for staff with no production role set. Production
 * roles themselves are the ProductionRole enum values; this is the one bucket
 * the enum has no value for.
 */
exports.NO_PRODUCTION_ROLE_KEY = "NONE";
